import { TextEditor, Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { COLLECTION_DESC, MAX_ADDITIONAL_THOUGHTS_LENGTH } from '@hero/constants';

import * as S from './style';

function CollectionDescription({ messageParams, onUpdateMessageParams }) {
  const { t } = useTranslation();

  return (
    <S.CollectionDescription id={COLLECTION_DESC}>
      <S.TitleWrapper>
        <Typography variant="body1Bold">{t('includeCollectionDescription')}</Typography>&nbsp;(
        <Typography variant="body2">{t('optional')}</Typography>):
      </S.TitleWrapper>
      <TextEditor
        key="about-message-editor"
        label={t('additionalThoughtsLabel')}
        value={messageParams?.aboutMessage}
        onChange={value => {
          onUpdateMessageParams({ aboutMessage: value });
        }}
        limit={MAX_ADDITIONAL_THOUGHTS_LENGTH}
      >
        {({ charCount }) => (
          <S.TextEditorFooterText variant="caption1">
            {t('lengthCharacters', {
              length: charCount,
              limit: MAX_ADDITIONAL_THOUGHTS_LENGTH
            })}
          </S.TextEditorFooterText>
        )}
      </TextEditor>
    </S.CollectionDescription>
  );
}

CollectionDescription.propTypes = {
  messageParams: PropTypes.object,
  onUpdateMessageParams: PropTypes.func
};

export { CollectionDescription };
